import React from 'react';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { AccountIconHelper } from '../../helpers/AccountIconsHelper';
import { weakKey } from '../../../../utilities/weakKey';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { tabletscreensize } from '../../../../utilities/constants';
import { LocationSection } from '../../helpers/LayoutComponents';

export const SideNavBar = ({
  sideBarConfig,
  currRef,
  locationName,
  closeSideNavBar,
  logOutLinkClickHandler,
}: AccountPanelTypes.TSideNavBar) => {
  const { width } = useWindowDimensions();

  return (
    <div
      className={`column sideNavBar ${width < tabletscreensize ? '' : 'is-5'}`}
      ref={currRef}
    >
      <div className="sideNavBarChildren">
        <LocationSection locationName={locationName} />
        {sideBarConfig.map(({ url, linkName, RenderAs }) => (
          <li key={weakKey({ url })}>
            <RenderAs
              to={`../${url}`}
              className="linkContainer has-text-primary"
              activeClassName="has-text-weight-bold active"
              replace
            >
              <div
                className="is-flex linkSection"
                onClick={() => width < tabletscreensize && closeSideNavBar()}
              >
                <span className="activeLinkBorder"></span>
                <h5 className="text">{linkName}</h5>
              </div>
            </RenderAs>
          </li>
        ))}
        <li>
          <a
            type="button"
            className="linkContainer has-text-primary is-clickable logOutListItem"
            onClick={logOutLinkClickHandler}
          >
            <h5 className="logOutText">Log Out</h5>
            <AccountIconHelper
              icon={'FaSignOutAlt'}
              color={'white'}
              size={'24'}
            />
          </a>
        </li>
      </div>
    </div>
  );
};
